var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3 0C9.77939 0 12.6 2.82061 12.6 6.3C12.6 7.78734 12.0846 9.15431 11.2226 10.232L13.795 12.805C14.0683 13.0784 14.0683 13.5216 13.795 13.795C13.5426 14.0473 13.1456 14.0667 12.871 13.8532L12.805 13.795L10.232 11.2226C9.15431 12.0846 7.78734 12.6 6.3 12.6C2.82061 12.6 0 9.77939 0 6.3C0 2.82061 2.82061 0 6.3 0ZM6.29998 1.39998C3.59378 1.39998 1.39998 3.59378 1.39998 6.29998C1.39998 9.00617 3.59378 11.2 6.29998 11.2C9.00617 11.2 11.2 9.00617 11.2 6.29998C11.2 3.59378 9.00617 1.39998 6.29998 1.39998Z",
    fill: "#101331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ca0ecac82ce36181da7b0128dd770e1e.svg";
export { ForwardRef as ReactComponent };